@if (loadingBarValue !== 0) {
  <ngx-loading-bar color="#d7a44e" height="0.15em"></ngx-loading-bar>
}

<pwj-header></pwj-header>
<pwj-order-quick-access></pwj-order-quick-access>
@if (isShadow) {
  <div class="shadow" (click)="closeBox()"></div>
}
<router-outlet></router-outlet>
<pwj-footer></pwj-footer>
<pwj-chat-box></pwj-chat-box>
